import { ITicket } from '@nkr/models/index';

export const helpers = {
    getContact: (ticket: ITicket) => {
        if (ticket != null) {
            let { id, fullName, email } = ticket.contact
            return { value: id.toString(), label: `${fullName} (${email})`, email };
        }

        return null;
    },

    getFromList: (firstName: string, lastName: string, userName: string, email: string) => {
        // return [
        //     { value: email, email, label: `${firstName} ${lastName} (${email})` },
        //     { value: `${userName}@donorscreen.org`, email: `${userName}@donorscreen.org`, label: `${firstName} ${lastName} (${userName}@donorscreen.org)` },
        //     { value: 'support@kidneyregistry.org', email: 'support@kidneyregistry.org', label: `${firstName} ${lastName} (support@kidneyregistry.org)` },
        //     { value: 'contact-us@kidneyregistry.org', email: 'contact-us@kidneyregistry.org', label: 'Contact Us (contact-us@kidneyregistry.org' }
        // ];
        return [
            { value: __TICKETINGEMAILADDRESS__, email: __TICKETINGEMAILADDRESS__, label: __TICKETINGEMAILADDRESS__ }
        ]
    }
}